import React from 'react';
import { createTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import { makeStyles } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import brLocale from 'date-fns/locale/pt-BR';
import { dateIsValid } from '../../helper/convertDate';

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

const useStyles = makeStyles(theme => ({
  textFieldParent: {
    boxShadow: '-2px 4px 5px 0px rgba(0, 0, 0, 0.1)',
    padding: '0 15px',
    height: 62,
    background: '#fff',
    width: '180px',
  },
  textField: {
    width: '100%',
    borderRadius: 2,
    fontSize: 20,
    margin: '5px 0px',
    [theme.breakpoints.down('sm')]: {
      margin: '10px 0px',
    },
  },
}));

const defaultMaterialTheme = createTheme({
  spacing: 5,
});

export default function DatePicker(props) {
  const classes = useStyles();
  const [selectedDate, setSelectedDate] = React.useState(props.DefaultValue);
  // const [invalidDateMessage, setInvalidDateMessage] = React.useState(props.DefaultValue);

  const handleDateChange = date => {
    let hasError = false
    let errorMessage = ""
    let currentDate = new Date().setHours(0, 0, 0, 0)

    if (!dateIsValid(date)) {
      hasError = true
      errorMessage = "Insira uma data de pagamento válida."
      date = 'a'
      setSelectedDate(date)
    } else if (date < currentDate) {
      hasError = true
      errorMessage = "A data de pagamento deve estar entre hoje e o último dia útil do mês."
      setSelectedDate(date)
    } else if (date > props.MaxDate) {
      hasError = true
      errorMessage = "A data de pagamento deve estar entre hoje e o último dia útil do mês."
      setSelectedDate(date)
    } else {
      setSelectedDate(date);
    }

    props.OnChangeMethod(date, hasError, errorMessage)
  };


  const disableWeekends = date => {
    return date.getDay() === 0 || date.getDay() === 6;
  }

  return (
    <ThemeProvider theme={defaultMaterialTheme}>
      <div className={classes.textFieldParent}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={brLocale}>
          <KeyboardDatePicker
            className={classes.textField}
            margin="normal"
            id="date-picker-dialog"
            label="Data de Pagamento"
            format="dd/MM/yyyy"
            value={selectedDate}
            disablePast='true'
            onChange={handleDateChange}
            shouldDisableDate={disableWeekends}
            // onError={handleError}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            okLabel="Ok"
            cancelLabel="Cancelar"
            invalidDateMessage="Data inválida."
            minDateMessage="A data inserida é inválida."
            maxDate={props.MaxDate}
          />
        </MuiPickersUtilsProvider>
      </div>
    </ThemeProvider>
  );
}